"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../../../../common/Button/Button"));
var DatePicker_1 = __importDefault(require("../../../../common/DatePicker/DatePicker"));
var Spinner_1 = __importDefault(require("../../../../common/Spinner/Spinner"));
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var general_1 = require("../../../../lib/general");
var Queries_1 = require("../Graphql/Queries");
var Validate_1 = require("../Validate");
var DropDown_1 = __importDefault(require("../../../../common/DropDown/DropDown"));
var AreaMappingCountReport = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var organization = (0, org_hook_1.useOrg)().organization, t = (0, react_i18next_1.useTranslation)().t, _o = (0, react_1.useState)(null), fromDate = _o[0], setFromDate = _o[1], _p = (0, react_1.useState)(null), toDate = _p[0], setToDate = _p[1], _q = (0, react_1.useState)(false), displayFromCalender = _q[0], setDisplayFromCalender = _q[1], _r = (0, react_1.useState)(false), displayToCalender = _r[0], setDisplayToCalender = _r[1], _s = (0, react_1.useState)(null), error = _s[0], setError = _s[1], _t = (0, react_1.useState)({ prev: null, current: null }), area1 = _t[0], setArea1 = _t[1], _u = (0, react_1.useState)({ prev: null, current: null }), area2 = _u[0], setArea2 = _u[1], _v = (0, react_1.useState)({ prev: null, current: null }), area3 = _v[0], setArea3 = _v[1], _w = (0, react_1.useState)({ prev: null, current: null }), area4 = _w[0], setArea4 = _w[1], _x = (0, react_1.useState)({ prev: null, current: null }), area5 = _x[0], setArea5 = _x[1], _y = (0, react_1.useState)({ prev: null, current: null }), group = _y[0], setGroup = _y[1], _z = (0, react_1.useState)([]), area1List = _z[0], setArea1List = _z[1], _0 = (0, react_1.useState)([]), area2List = _0[0], setArea2List = _0[1], _1 = (0, react_1.useState)([]), area3List = _1[0], setArea3List = _1[1], _2 = (0, react_1.useState)([]), area4List = _2[0], setArea4List = _2[1], _3 = (0, react_1.useState)([]), area5List = _3[0], setArea5List = _3[1], _4 = (0, react_1.useState)([]), groupList = _4[0], setGroupList = _4[1], _5 = (0, client_1.useLazyQuery)(Queries_1.GET_ADDRESS_LABEL, {
        fetchPolicy: 'network-only',
    }), callAddressLabel = _5[0], responseAddressLabel = _5[1], _6 = (0, client_1.useLazyQuery)(Queries_1.GET_ADDRESS_LIST, {
        fetchPolicy: 'network-only',
    }), callAdressList = _6[0], responseAddressList = _6[1];
    (0, react_1.useEffect)(function () {
        callAddressLabel();
    }, []);
    (0, react_1.useEffect)(function () {
        getAddressList();
    }, [area1, area2, area3, area4, area5, group]);
    var getAddressList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, callAdressList({
                        variables: {
                            area1: area1.current,
                            area2: area2.current,
                            area3: area3.current,
                            area4: area4.current,
                            area5: area5.current,
                            group: group.current,
                        },
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if ((responseAddressList === null || responseAddressList === void 0 ? void 0 : responseAddressList.data) != null &&
            responseAddressList.data != undefined) {
            setAddressLists();
        }
    }, [responseAddressList]);
    var setAddressLists = function () { return __awaiter(void 0, void 0, void 0, function () {
        var list;
        var _a;
        return __generator(this, function (_b) {
            list = (_a = responseAddressList === null || responseAddressList === void 0 ? void 0 : responseAddressList.data) === null || _a === void 0 ? void 0 : _a.getAddressList;
            area1.current === null &&
                setArea1List(__spreadArray([], list.map(function (val) {
                    return { label: val.area1, value: val.area1 };
                }), true));
            area2.current === null &&
                area1.current != null &&
                setArea2List(__spreadArray([], list.map(function (val) {
                    return { label: val.area2, value: val.area2 };
                }), true));
            area3.current === null &&
                area1.current != null &&
                area2.current != null &&
                setArea3List(__spreadArray([], list.map(function (val) {
                    return { label: val.area3, value: val.area3 };
                }), true));
            area4.current === null &&
                area1.current != null &&
                area2.current != null &&
                area3.current != null &&
                setArea4List(__spreadArray([], list.map(function (val) {
                    return { label: val.area4, value: val.area4 };
                }), true));
            area5.current === null &&
                area1.current != null &&
                area2.current != null &&
                area3.current != null &&
                area4.current != null &&
                setArea5List(__spreadArray([], list.map(function (val) {
                    return { label: val.area5, value: val.area5 };
                }), true));
            group.current === null &&
                area1.current != null &&
                area2.current != null &&
                area3.current != null &&
                area4.current != null &&
                area5.current != null &&
                setGroupList(__spreadArray([], list.map(function (val) {
                    return { label: val.group, value: val.group };
                }), true));
            return [2 /*return*/];
        });
    }); };
    var _7 = (0, client_1.useLazyQuery)(Queries_1.AREA_MAPPING_COUNT_REPORT, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        onCompleted: function (e) {
            var linkSource = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,".concat(e.generateAreaMappingCountReport.content);
            var downloadLink = document.createElement('a');
            var fileName = e.generateAreaMappingCountReport.name;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        },
        onError: function (error) {
            console.log({ error: error });
        },
    }), generateAreaMappingCountReport = _7[0], loading = _7[1].loading;
    var onClick = function () {
        var params = {
            to: toDate ? (0, general_1.getDateFormat)(toDate) : null,
            from: fromDate ? (0, general_1.getDateFormat)(fromDate) : null,
            organization_id: organization.id,
            area1: area1.current,
            area2: area2.current,
            area3: area3.current,
            area4: area4.current,
            area5: area5.current,
            group: group.current,
        };
        var validateResponse = Validate_1.reportValidate.areaMapping(params);
        if (validateResponse.status === 'success') {
            generateAreaMappingCountReport({
                variables: params,
            });
        }
        else {
            setError(validateResponse);
        }
    };
    var commonChange = function () {
        setDisplayFromCalender(false);
        setDisplayToCalender(false);
        setError(null);
    };
    return (react_1.default.createElement("div", null,
        loading && react_1.default.createElement(Spinner_1.default, null),
        react_1.default.createElement(DatePicker_1.default, { error: error && error.field === 'from' && error.message, title: t('from_date'), onClick: function () {
                setDisplayFromCalender(!displayFromCalender);
                setDisplayToCalender(false);
            }, onChange: function (date) {
                setFromDate(date);
                commonChange();
            }, value: fromDate, show: displayFromCalender }),
        react_1.default.createElement(DatePicker_1.default, { error: error && error.field === 'to' && error.message, title: t('to_date'), onClick: function () {
                setDisplayToCalender(!displayToCalender);
                setDisplayFromCalender(false);
            }, onChange: function (date) {
                setToDate(date);
                commonChange();
            }, value: toDate, show: displayToCalender }),
        react_1.default.createElement(DropDown_1.default, { options: area1List, isMulti: false, label: (_b = (_a = responseAddressLabel === null || responseAddressLabel === void 0 ? void 0 : responseAddressLabel.data) === null || _a === void 0 ? void 0 : _a.getAddressLabel) === null || _b === void 0 ? void 0 : _b.area1, onChange: function (e) {
                setArea1({ prev: area1.current, current: e.value });
                setArea2({ prev: area2.current, current: null });
                setArea3({ prev: area3.current, current: null });
                setArea4({ prev: area4.current, current: null });
                setArea5({ prev: area5.current, current: null });
                setGroup({ prev: group.current, current: null });
                commonChange();
            }, value: area1.current }),
        react_1.default.createElement(DropDown_1.default, { options: area2List, isMulti: false, label: (_d = (_c = responseAddressLabel === null || responseAddressLabel === void 0 ? void 0 : responseAddressLabel.data) === null || _c === void 0 ? void 0 : _c.getAddressLabel) === null || _d === void 0 ? void 0 : _d.area2, onChange: function (e) {
                setArea2({ prev: area2.current, current: e.value });
                setArea3({ prev: area3.current, current: null });
                setArea4({ prev: area4.current, current: null });
                setArea5({ prev: area5.current, current: null });
                setGroup({ prev: group.current, current: null });
                commonChange();
            }, value: area2.current }),
        react_1.default.createElement(DropDown_1.default, { options: area3List, isMulti: false, label: (_f = (_e = responseAddressLabel === null || responseAddressLabel === void 0 ? void 0 : responseAddressLabel.data) === null || _e === void 0 ? void 0 : _e.getAddressLabel) === null || _f === void 0 ? void 0 : _f.area3, onChange: function (e) {
                setArea3({ prev: area3.current, current: e.value });
                setArea4({ prev: area4.current, current: null });
                setArea5({ prev: area5.current, current: null });
                setGroup({ prev: group.current, current: null });
                commonChange();
            }, value: area3.current }),
        react_1.default.createElement(DropDown_1.default, { options: area4List, isMulti: false, label: (_h = (_g = responseAddressLabel === null || responseAddressLabel === void 0 ? void 0 : responseAddressLabel.data) === null || _g === void 0 ? void 0 : _g.getAddressLabel) === null || _h === void 0 ? void 0 : _h.area4, onChange: function (e) {
                setArea4({ prev: area4.current, current: e.value });
                setArea5({ prev: area5.current, current: null });
                setGroup({ prev: group.current, current: null });
                commonChange();
            }, value: area4.current }),
        react_1.default.createElement(DropDown_1.default, { options: area5List, isMulti: false, label: (_k = (_j = responseAddressLabel === null || responseAddressLabel === void 0 ? void 0 : responseAddressLabel.data) === null || _j === void 0 ? void 0 : _j.getAddressLabel) === null || _k === void 0 ? void 0 : _k.area5, onChange: function (e) {
                setArea5({ prev: area5.current, current: e.value });
                setGroup({ prev: group.current, current: null });
                commonChange();
            }, value: area5.current }),
        react_1.default.createElement(DropDown_1.default, { options: groupList, isMulti: false, label: (_m = (_l = responseAddressLabel === null || responseAddressLabel === void 0 ? void 0 : responseAddressLabel.data) === null || _l === void 0 ? void 0 : _l.getAddressLabel) === null || _m === void 0 ? void 0 : _m.group, onChange: function (e) {
                setGroup({ prev: group.current, current: e.value });
                commonChange();
            }, value: group.current }),
        react_1.default.createElement(Button_1.default, { className: 'form-buttom', text: t('generate_report'), onClick: function () { return onClick(); } })));
};
exports.default = AreaMappingCountReport;
